import { render, staticRenderFns } from "./SContracts.vue?vue&type=template&id=97c48c92&scoped=true&"
import script from "./SContracts.vue?vue&type=script&async=true&lang=js&"
export * from "./SContracts.vue?vue&type=script&async=true&lang=js&"
import style0 from "./SContracts.vue?vue&type=style&index=0&id=97c48c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c48c92",
  null
  
)

export default component.exports